import { createSlice } from '@reduxjs/toolkit';
import { brandBaanInitialState } from './initialState';
import {
  checkBrandStatus,
  getBrandBaanProfiles,
  getBrandBaanVoiceShare,
  getBrandBaanContents,
  getBrandBaanComments,
  getBrandBaanBrands,
  getBrandBaanReportage,
  getBrandBaanProfileOverview,
  getBrandBaanCommnetsEmojis,
  getBrandBaanVoiceTrend,
  getBrandBaanReportageKeywordList,
  getReportageListByKeyword,
  getBrandBaanStoryPublicationComparison,
  getBrandBaanStoryPublishment,
  getBrandBaanStoryAnalytics,
  getBrandBaanDetails,
  getBrandBaanNss,
  getBrandBaanNssTrend,
} from './actions';

export const brandBaanSlice = createSlice({
  name: 'brandBaanSlice',
  initialState: brandBaanInitialState,
  extraReducers: (builder) => {
    builder
      .addCase(getBrandBaanProfiles.fulfilled, (state, action) => {
        state.profiles.data = action.payload;
        state.profiles.loading = false;
        state.profiles.error = null;
      })
      .addCase(getBrandBaanProfiles.pending, (state) => {
        state.profiles.loading = true;
        state.profiles.error = null;
      })
      .addCase(getBrandBaanProfiles.rejected, (state, action) => {
        state.profiles.loading = false;
        state.profiles.error = action.payload;
      })
      .addCase(getBrandBaanVoiceShare.fulfilled, (state, action) => {
        state.voice.data = action.payload;
        state.voice.loading = false;
        state.voice.error = null;
      })
      .addCase(getBrandBaanVoiceShare.pending, (state) => {
        state.voice.loading = true;
        state.voice.error = null;
      })
      .addCase(getBrandBaanVoiceShare.rejected, (state, action) => {
        state.voice.loading = false;
        state.voice.error = action.payload;
      })
      .addCase(getBrandBaanNss.fulfilled, (state, action) => {
        state.nss.data = action.payload;
        state.nss.loading = false;
        state.nss.error = null;
      })
      .addCase(getBrandBaanNss.pending, (state) => {
        state.nss.loading = true;
        state.nss.error = null;
      })
      .addCase(getBrandBaanNss.rejected, (state, action) => {
        state.nss.loading = false;
        state.nss.error = action.payload;
      })
      .addCase(getBrandBaanNssTrend.fulfilled, (state, action) => {
        state.nssTrend.data = action.payload;
        state.nssTrend.loading = false;
        state.nssTrend.error = null;
      })
      .addCase(getBrandBaanNssTrend.pending, (state) => {
        state.nssTrend.loading = true;
        state.nssTrend.error = null;
      })
      .addCase(getBrandBaanNssTrend.rejected, (state, action) => {
        state.nssTrend.loading = false;
        state.nssTrend.error = action.payload;
      })
      .addCase(getBrandBaanContents.fulfilled, (state, action) => {
        state.contents.data = action.payload;
        state.contents.loading = false;
        state.contents.error = null;
      })
      .addCase(getBrandBaanContents.pending, (state) => {
        state.contents.loading = true;
        state.contents.error = null;
      })
      .addCase(getBrandBaanContents.rejected, (state, action) => {
        state.contents.loading = false;
        state.contents.error = action.payload;
      })
      .addCase(getBrandBaanComments.fulfilled, (state, action) => {
        state.comments.data = action.payload;
        state.comments.loading = false;
        state.comments.error = null;
      })
      .addCase(getBrandBaanComments.pending, (state) => {
        state.comments.loading = true;
        state.comments.error = null;
      })
      .addCase(getBrandBaanComments.rejected, (state, action) => {
        state.comments.loading = false;
        state.comments.error = action.payload;
      })
      .addCase(checkBrandStatus.pending, (state) => {
        state.checkStatus.loading = true;
        state.checkStatus.error = null;
      })
      .addCase(checkBrandStatus.fulfilled, (state, action) => {
        state.checkStatus.loading = false;
        state.checkStatus.data = action.payload;
      })
      .addCase(checkBrandStatus.rejected, (state, action) => {
        state.checkStatus.loading = false;
        state.checkStatus.error = action.payload;
      })
      .addCase(getBrandBaanBrands.fulfilled, (state, action) => {
        state.brands.data = action.payload;
        state.brands.loading = false;
        state.brands.error = null;
      })
      .addCase(getBrandBaanBrands.pending, (state) => {
        state.brands.loading = true;
        state.brands.error = null;
      })
      .addCase(getBrandBaanBrands.rejected, (state, action) => {
        state.brands.loading = false;
        state.brands.error = action.payload;
      })
      .addCase(getBrandBaanReportage.fulfilled, (state, action) => {
        state.reportage.data = action.payload.data;
        state.reportage.loading = false;
        state.reportage.error = null;
      })
      .addCase(getBrandBaanReportage.pending, (state) => {
        state.reportage.loading = true;
        state.reportage.error = null;
      })
      .addCase(getBrandBaanReportage.rejected, (state, action) => {
        state.reportage.loading = false;
        state.reportage.error = action.payload;
      })
      .addCase(getBrandBaanProfileOverview.fulfilled, (state, action) => {
        state.profileOverview.data = action.payload;
        state.profileOverview.loading = false;
        state.profileOverview.error = null;
      })
      .addCase(getBrandBaanProfileOverview.pending, (state) => {
        state.profileOverview.loading = true;
        state.profileOverview.error = null;
      })
      .addCase(getBrandBaanProfileOverview.rejected, (state, action) => {
        state.profileOverview.loading = false;
        state.profileOverview.error = action.payload;
      })
      .addCase(getBrandBaanCommnetsEmojis.fulfilled, (state, action) => {
        state.commentsEmojis.data = action.payload;
        state.commentsEmojis.loading = false;
        state.commentsEmojis.error = null;
      })
      .addCase(getBrandBaanCommnetsEmojis.pending, (state) => {
        state.commentsEmojis.loading = true;
        state.commentsEmojis.error = null;
      })
      .addCase(getBrandBaanCommnetsEmojis.rejected, (state, action) => {
        state.commentsEmojis.loading = false;
        state.commentsEmojis.error = action.payload;
      })
      .addCase(getBrandBaanVoiceTrend.fulfilled, (state, action) => {
        state.voiceTrend.data = action.payload;
        state.voiceTrend.loading = false;
        state.voiceTrend.error = null;
      })
      .addCase(getBrandBaanVoiceTrend.pending, (state) => {
        state.voiceTrend.loading = true;
        state.voiceTrend.error = null;
      })
      .addCase(getBrandBaanVoiceTrend.rejected, (state, action) => {
        state.voiceTrend.loading = false;
        state.voiceTrend.error = action.payload;
      })
      .addCase(getBrandBaanReportageKeywordList.pending, (state) => {
        state.reportageKeywords.loading = true;
        state.reportageKeywords.error = null;
      })
      .addCase(getBrandBaanReportageKeywordList.fulfilled, (state, action) => {
        state.reportageKeywords.data = action.payload.data;
        state.reportageKeywords.total = action.payload.meta.total;
        state.reportageKeywords.loading = false;
        state.reportageKeywords.error = null;
      })
      .addCase(getBrandBaanReportageKeywordList.rejected, (state, action) => {
        state.reportageKeywords.loading = false;
        state.reportageKeywords.error = action.payload;
      })
      .addCase(getReportageListByKeyword.pending, (state) => {
        state.reportageList.loading = true;
        state.reportageList.error = null;
        state.reportageList.data = [];
      })
      .addCase(getReportageListByKeyword.fulfilled, (state, action) => {
        state.reportageList.data = action.payload.data;
        state.reportageList.total = action.payload.total;
        state.reportageList.page = action.payload.page;
        state.reportageList.loading = false;
        state.reportageList.error = null;
      })
      .addCase(getReportageListByKeyword.rejected, (state, action) => {
        state.reportageList.loading = false;
        state.reportageList.error = action.payload;
        state.reportageList.data = [];
      })
      .addCase(getBrandBaanStoryPublicationComparison.pending, (state) => {
        state.storyPublicationComparison.loading = true;
        state.storyPublicationComparison.error = null;
        state.storyPublicationComparison.data = [];
      })
      .addCase(
        getBrandBaanStoryPublicationComparison.fulfilled,
        (state, action) => {
          state.storyPublicationComparison.data = action.payload;
          state.storyPublicationComparison.loading = false;
          state.storyPublicationComparison.error = null;
        }
      )
      .addCase(
        getBrandBaanStoryPublicationComparison.rejected,
        (state, action) => {
          state.storyPublicationComparison.loading = false;
          state.storyPublicationComparison.error = action.payload;
          state.storyPublicationComparison.data = [];
        }
      )
      .addCase(getBrandBaanStoryPublishment.pending, (state) => {
        state.storyPublishment.loading = true;
        state.storyPublishment.error = null;
        state.storyPublishment.data = [];
      })
      .addCase(getBrandBaanStoryPublishment.fulfilled, (state, action) => {
        state.storyPublishment.data = action.payload;
        state.storyPublishment.loading = false;
        state.storyPublishment.error = null;
      })
      .addCase(getBrandBaanStoryPublishment.rejected, (state, action) => {
        state.storyPublishment.loading = false;
        state.storyPublishment.error = action.payload;
        state.storyPublishment.data = [];
      })
      .addCase(getBrandBaanStoryAnalytics.pending, (state) => {
        state.storyAnalytics.loading = true;
        state.storyAnalytics.error = null;
      })
      .addCase(getBrandBaanStoryAnalytics.fulfilled, (state, action) => {
        state.storyAnalytics.data = action.payload;
        state.storyAnalytics.loading = false;
        state.storyAnalytics.error = null;
      })
      .addCase(getBrandBaanStoryAnalytics.rejected, (state, action) => {
        state.storyAnalytics.loading = false;
        state.storyAnalytics.error = action.payload;
        state.storyAnalytics.data = [];
      })
      .addCase(getBrandBaanDetails.pending, (state) => {
        state.brandDetails.loading = true;
        state.brandDetails.error = null;
      })
      .addCase(getBrandBaanDetails.fulfilled, (state, action) => {
        state.brandDetails.data = action.payload;
        state.brandDetails.loading = false;
        state.brandDetails.error = null;
      })
      .addCase(getBrandBaanDetails.rejected, (state, action) => {
        state.brandDetails.loading = false;
        state.brandDetails.error = action.payload;
      });
  },
});
